import { useState } from "react";
import { Box } from "@mui/material";
import YouTubeIcon from "@mui/icons-material/YouTube";

interface YouTubePreviewProps {
  videoId: string;
  height?: string | number;
  className?: string;
}

const YouTubePreview = ({
  videoId,
  height = 225,
  className,
}: YouTubePreviewProps) => {
  const [play, setPlay] = useState(false);

  const thumbnail = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

  return (
    <Box
      className={className}
      sx={{
        height,
        position: "relative",
        cursor: "pointer",
        borderRadius: "8px",
        overflow: "hidden",
      }}
      onClick={() => setPlay(true)}
    >
      {play ? (
        <iframe
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{ width: "100%", height: "100%" }}
        />
      ) : (
        <>
          {/* Thumbnail */}
          <Box
            component="img"
            src={thumbnail}
            alt="YouTube preview"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />

          {/* YouTube Icon Overlay */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              pointerEvents: "none",
            }}
          >
            <YouTubeIcon
              sx={{
                fontSize: 64,
                color: "#FF0000",
                backgroundColor: "white",
                borderRadius: "50%",
              }}
            />
          </Box>
        </>
      )}

      {/* Watch on YouTube */}
      {!play && (
        <Box
          component="a"
          href={`https://www.youtube.com/watch?v=${videoId}`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          sx={{
            position: "absolute",
            bottom: 8,
            left: 8,
            bgcolor: "rgba(0,0,0,0.7)",
            color: "white",
            px: 1.5,
            py: 0.5,
            borderRadius: "4px",
            fontSize: "12px",
            textDecoration: "none",
          }}
        >
          Watch on YouTube
        </Box>
      )}
    </Box>
  );
};

export default YouTubePreview;
